import React, { useEffect, useRef } from "react";
import { api, setAuthToken } from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    if (!session_id) {
      window.location.replace("/");
      return;
    }
    (async () => {
      // Determine where to send the user after auth completes
      let returnTo = "/dashboard";
      try {
        const stored = window.sessionStorage.getItem("post_login_return");
        if (stored && stored.startsWith("/")) returnTo = stored;
        window.sessionStorage.removeItem("post_login_return");
      } catch (_e) { /* sessionStorage disabled — fall back to /dashboard */ }
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Persist token as Bearer fallback — cookies may be blocked in some browsers
        if (data?.session_token) setAuthToken(data.session_token);
        window.location.replace(returnTo);
      } catch (e) {
        window.location.replace("/");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-background text-foreground">
      <p className="font-mono text-xs tracking-[0.18em] uppercase text-white/60">Signing you in…</p>
    </div>
  );
}
